import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const SantanderMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4051" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="#CC0000"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4051)"
      />
      <Path
        d="M28.3831 15.2578C28.3374 14.5831 28.1548 13.9084 27.7895 13.3236L24.6846 7.97101C24.4563 7.56619 24.2736 7.1164 24.1823 6.6666L24.0453 6.8915C23.2691 8.19591 23.2691 9.86017 24.0453 11.1646L26.5567 15.4377C27.3329 16.7421 27.3329 18.4064 26.5567 19.7108L26.4197 19.9357C26.3284 19.4859 26.1457 19.0361 25.9174 18.6313L23.6344 14.718L22.1732 12.1991C21.9449 11.7943 21.7623 11.3445 21.671 10.8947L21.534 11.1196C20.7578 12.424 20.7578 14.0433 21.534 15.3927L24.0453 19.6658C24.8216 20.9702 24.8216 22.6345 24.0453 23.9389L23.9083 24.1638C23.817 23.714 23.6344 23.2642 23.4061 22.8594L20.2555 17.5068C19.8446 16.7871 19.6619 15.9774 19.6619 15.1678C16.3287 16.0224 14 17.8666 14 19.9807C14 22.9493 18.4747 25.3333 23.9997 25.3333C29.5246 25.3333 33.9993 22.9493 33.9993 19.9807C34.045 17.9566 31.762 16.1124 28.3831 15.2578Z"
        fill="white"
      />
    </Svg>
  )
}
